import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'up-feature-card-default',
  templateUrl: './feature-card-default.component.html',
  styleUrls: ['./feature-card-default.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeatureCardDefaultComponent {
  static itemCounter = 0;
  @Input() header = 'Card Default';
  @Input() editable = false;
  @Input() considerable = true;
  @Input() delete = false;
  @Input() ignore: any = null;
  @Input() status = 0;
  @Input() docId: string;
  @Input() infos: any;
  @Input() initialized = true;
  @Input() customStyle: string;
  @Input() newBrand: boolean;
  @Input() disabledEdit: boolean;

  @Output()
  emitterDocument: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  ignoreDoc: EventEmitter<any> = new EventEmitter<any>();

  itemId = 'card-id' + FeatureCardDefaultComponent.itemCounter;
  editing = false;
  userEmail: string;
  employee: any;
  action = false;

  constructor() {
    FeatureCardDefaultComponent.itemCounter++;
  }

  @HostListener('document:click', ['$event'])
  clickedOutside(): void {
    this.action = false;
  }

  deactiveEdit(): void {
    this.editing = false;
  }

  // Generic function with generic event emitter to employee dependents component
  actionDocument(): void {
    this.emitterDocument.emit(this.infos);
  }

  deleteDocument(): void {
    this.ignoreDoc.emit(true);
  }

  openActions(e): void {
    e.preventDefault();
    e.stopPropagation();
    this.action = !this.action;
  }

  activeEdit(): void {
    this.editing = true;
  }

  clickInside(e): void {
    e.preventDefault();
    e.stopPropagation();
  }
}
